
jQuery(document).ready(function ($) {

    /**
     * ARCHIVE / TAXONOMIE : apparition des tuiles au chargement
     */
    const $tiles = $('body.post-type-archive-realisations .liste_articles .tile, body.tax-categories-realisations .liste_articles .tile')
    if ($tiles.length) {
        gsap.to($tiles, {
            autoAlpha: 1,
            y: 0,
            duration: 0.7,
            stagger: 0.08,
            ease: 'power3.out',
            onComplete: () => {
                gsap.set($tiles, { clearProps: 'transition,animation' })
            }
        })
    }

    /**
     * SINGLE : apparition de la thumbnail
     */
    const $visuel = $('body.single-realisations .bloc_hdp .visuel')
    if ($visuel.length) {
        gsap.to($visuel, {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: 'power3.out',
            onComplete: () => {
                gsap.set($visuel, { clearProps: 'transition,animation' })
            }
        })
    }

    /**
     * SINGLE : lightbox galerie
     */
    const $gallery = $('body.single-realisations .galerie')
    if (!$gallery.length) return

    const $links = $gallery.find('> a')
    if (!$links.length) return

    /**
     * SINGLE : apparition des éléments de la galerie
     */
    gsap.to($links, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.08,
        ease: 'power3.out',
        onComplete: () => {
            gsap.set($links, { clearProps: 'transition,animation' })
        }
    })

    const $overlay = $(
        '<div class="rea-lightbox" aria-hidden="true">' +
        '  <button type="button" class="rea-lightbox__close" aria-label="Fermer"><i class="fa-light fa-xmark"></i></button>' +
        '  <button type="button" class="rea-lightbox__prev" aria-label="Précédent"><i class="fa-light fa-chevron-left"></i></button>' +
        '  <button type="button" class="rea-lightbox__next" aria-label="Suivant"><i class="fa-light fa-chevron-right"></i></button>' +
        '  <div class="rea-lightbox__stage"><img alt="" /></div>' +
        '</div>'
    ).appendTo('body')

    const $stage = $overlay.find('.rea-lightbox__stage')
    const $img = $overlay.find('img')
    let index = 0
    let isOpen = false

    function show(i) {
        index = (i + $links.length) % $links.length
        const src = $links.eq(index).attr('href')

        gsap.to($stage, {
            autoAlpha: 0,
            scale: 0.96,
            duration: 0.2,
            ease: 'power2.in',
            onComplete: () => {
                $img.attr('src', src)
                $img.one('load', () => {
                    gsap.fromTo(
                        $stage,
                        { autoAlpha: 0, scale: 0.96 },
                        { autoAlpha: 1, scale: 1, duration: 0.35, ease: 'power2.out' }
                    )
                })
            }
        })
    }

    function open(i) {
        if (isOpen) return
        isOpen = true
        $overlay.attr('aria-hidden', 'false').addClass('is-open')
        $('html').addClass('rea-lightbox-active')
        gsap.fromTo($overlay, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, ease: 'power2.out' })
        show(i)
    }

    function close() {
        if (!isOpen) return
        isOpen = false
        gsap.to($overlay, {
            autoAlpha: 0,
            duration: 0.25,
            ease: 'power2.in',
            onComplete: () => {
                $overlay.attr('aria-hidden', 'true').removeClass('is-open')
                $('html').removeClass('rea-lightbox-active')
                $img.attr('src', '')
                gsap.set($stage, { clearProps: 'all' })
            }
        })
    }

    $links.on('click', function (e) {
        e.preventDefault()
        open($links.index(this))
    })

    $overlay.on('click', function (e) {
        if (e.target === this) close()
    })

    $overlay.find('.rea-lightbox__close').on('click', close)
    $overlay.find('.rea-lightbox__prev').on('click', function (e) {
        e.stopPropagation()
        show(index - 1)
    })
    $overlay.find('.rea-lightbox__next').on('click', function (e) {
        e.stopPropagation()
        show(index + 1)
    })

    $(document).on('keydown', function (e) {
        if (!isOpen) return
        if (e.key === 'Escape') close()
        else if (e.key === 'ArrowLeft') show(index - 1)
        else if (e.key === 'ArrowRight') show(index + 1)
    })

})
